import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_URL } from '#const';

// Separate API for public endpoints that don't require authentication
export const publicSharedApi = createApi({
  reducerPath: 'publicSharedAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
      // Explicitly don't set Authorization header for public endpoints
      // This allows access without authentication
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchSharedData: builder.query({
      query: ({ token, code }) => ({
        url: `/shared/${token}/`,
        method: 'GET',
        params: code ? { code } : {},
      }),
      // Don't cache responses - always fetch fresh data
      keepUnusedDataFor: 0,
    }),
    fetchBiomarkerGroups: builder.query({
      query: ({ token, language }) => ({
        url: `/shared/${token}/biomarkers/groups/`,
        method: 'GET',
        params: language ? { language } : {},
      }),
      transformResponse: (response) => {
        // Transform response to match laboratoryTestsApi format
        if (!response || typeof response !== 'object') {
          return { results: [], count: 0, float_values: {}, string_values: {} };
        }

        const float_values = response.float_values || {};
        const string_values = response.string_values || {};

        // Combine float_values and string_values into a single results array
        const results = [
          ...Object.entries(float_values).map(([key, value]) => ({ key, value, type: 'float' })),
          ...Object.entries(string_values).map(([key, value]) => ({ key, value, type: 'string' })),
        ];
        const count = results.length;

        return {
          results,
          count,
          float_values,
          string_values,
        };
      },
    }),
    resendVerificationCode: builder.mutation({
      query: ({ token }) => ({
        url: `/shared/${token}/resend-code/`,
        method: 'POST',
      }),
    }),
    unsubscribeByToken: builder.mutation({
      query: ({ token, email }) => ({
        url: `/unsubscribe/${token}/`,
        method: 'POST',
        params: email ? { email } : {},
      }),
    }),
  }),
});

export const { 
  useLazyFetchSharedDataQuery, 
  useFetchSharedDataQuery, 
  useFetchBiomarkerGroupsQuery,
  useResendVerificationCodeMutation,
  useUnsubscribeByTokenMutation,
} = publicSharedApi;

